import * as React from 'react';
import { SBLogo } from '../../assets/images';

const Logo: React.FunctionComponent = (): JSX.Element => {
  return (
    <div className="gray-border-line flex h-20 items-center justify-center border-b">
      <img className="w-4/5" src={SBLogo} alt="Logo" />
    </div>
  );
};

export default Logo;
